import React, { useEffect, useState } from "react";
import AdminsTable from "../organisms/admins/TableAdmins";
import CreateAdmin from "../organisms/admins/CreateAdmin";
import { GET_ADMINS } from "../../api/apiAdmin";
import GlobalSearch from "../organisms/buscadores/GlobalSearch";
import CardTables from "../atoms/CardTables";
import Fuse from "fuse.js";
import CardHeader from "../atoms/CardHeader";
import Breadcrumb from "../molecules/Breadcrumb";

const AdminsTemplate = () => {
    const [admins, setAdmins] = useState();
    const [filteredAdmins, setFilteredAdmins] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({ user: "", email: "" });

    const getAdmins = async () => {
		try {
            setLoading(true);
			const adminsData = await GET_ADMINS();
            const filterData = adminsData.filter(admin => admin.isSuperAdmin);
            const sortedData = filterData.sort((a, b) => a.id - b.id);
            setAdmins(sortedData);
            setFilteredAdmins(sortedData);
		} catch (error) {
			console.error(error);
		} finally {
            setLoading(false);
        }
	};

	useEffect(() => { 
        getAdmins(); 
    }, []);

    useEffect(() => {
        if (!admins) return;

        const options = {
            keys: ["name", "user.email"],
            threshold: 0.3,
        };

        const fuse = new Fuse(admins, options);

        const searchTerms = `${filters.user} ${filters.email}`.trim();

        if (searchTerms) {
            const results = fuse.search(searchTerms).map(result => result.item);
            setFilteredAdmins(results);
        } else {
            setFilteredAdmins(admins);
        }
    }, [filters, admins]);

    return(
        <div className="h-full w-full flex flex-col space-y-2">
            <CardHeader>
                <Breadcrumb
                    items={[
                        { label: "Usuarios", to: "/usuarios" },
                        { label: "Administradores", to: null },
                    ]}
                />
                <CreateAdmin refetch={getAdmins} />
            </CardHeader>
            <CardTables>
                <GlobalSearch filters={filters} setFilters={setFilters} />
                <AdminsTable loading={loading} data={filteredAdmins} refetch={getAdmins}/>
            </CardTables>
        </div>
    )
};

export default AdminsTemplate;